import { request } from './client'

/* ── W-75: WHAT CAN BE WRONG WITH A ROOM (Sprint 63) ────────────────────────────

   **THIS FILE IS A CORRECTION (#166).** The list of fault categories was hardcoded twice
   — once in the web's dictionary and once, separately, in the handset's — with nothing on
   the server that had ever heard of a category. The two copies said different words for
   the same code (`PLUMBING` was "Plumbing" on the desk and "Water or drain" on the phone),
   and no hotel could change either without a release.

   Requests were given a table for exactly these reasons in Sprint 56. Faults were left
   behind until now. */

/** One kind of thing that can be wrong, as a picker draws it. */
export interface FaultCategory {
  /** Never translated. What every fault report counts by. */
  code: string
  name: string
  nameAr: string | null
}

/**
 * **THE ACTIVE ONES ONLY, AND NO ADMINISTRATION PERMISSION.** An attendant reporting a
 * broken lock has to be able to see the list of things that can be broken; a retired
 * category is one the hotel has said it does not want new faults filed under.
 */
export const fetchFaultCategories = (
  propertyId: string,
  options: { signal?: AbortSignal } = {},
) => request<FaultCategory[]>(
  `/properties/${propertyId}/fault-categories`,
  options.signal ? { signal: options.signal } : {},
)

/* ── and the administration half, W-75's screen ──────────────────────────────── */

export interface FaultCategoryRow {
  categoryId: string
  code: string
  name: string
  nameAr: string | null
  sortOrder: number
  isActive: boolean
  /** What decides whether the delete button is drawn at all. */
  faultsEverRaised: number
  /** Retiring does not close these — they keep their code and finish normally. */
  openFaults: number
}

export const fetchFaultCategoryAdmin = (
  propertyId: string,
  options: { signal?: AbortSignal } = {},
) => request<FaultCategoryRow[]>(
  `/properties/${propertyId}/fault-categories/admin`,
  options.signal ? { signal: options.signal } : {},
)

export const addFaultCategory = (
  propertyId: string,
  body: { code: string; name: string; nameAr: string | null },
) => request<FaultCategoryRow[]>(`/properties/${propertyId}/fault-categories`, {
  method: 'POST', body,
})

export const saveFaultCategory = (
  propertyId: string,
  categoryId: string,
  body: { name: string; nameAr: string | null; sortOrder?: number | null },
) => request<FaultCategoryRow[]>(
  `/properties/${propertyId}/fault-categories/${categoryId}`, { method: 'PUT', body })

export const setFaultCategoryActive = (
  propertyId: string,
  categoryId: string,
  isActive: boolean,
) => request<FaultCategoryRow[]>(
  `/properties/${propertyId}/fault-categories/${categoryId}/active`,
  { method: 'PUT', body: { isActive } })

export const deleteFaultCategory = (
  propertyId: string,
  categoryId: string,
) => request<FaultCategoryRow[]>(
  `/properties/${propertyId}/fault-categories/${categoryId}`, { method: 'DELETE' })
